export default (state, action) => {
  const { type, payload } = action

  switch (type) {
    case "SET_STARTING_DATE":
      return { ...state, startingDate: payload }
    case "SET_NOTIFICATION":
      if(payload.type) return { 
        ...state,
        notificationTitle: payload.title, 
        notificationType: payload.type 
      }
      return { ...state, notificationTitle: payload }
    default:
      return state
  }
}